/* eslint-disable indent */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';

import { useImg, usePicture, useText } from 'hooks';
import { MOBILE, TABLET, DESKTOP, TO_DESKTOP } from 'helpers/styles/media';

import FormBlock from '../Form/FormBlock';
import { FormWrapperStyles } from '../UI/UI';

const Top = ({ isOpen }) => {
  return (
    <Wrapper>
      <TopContainer>
        <Content>
          <Logo>{useImg('image_top.webp', 'image_top')}</Logo>
          <Title>{useText('top__title', true)}</Title>
          <Text>{useText('top__text', true)}</Text>
        </Content>
        <ImageDesktop>{usePicture('hero.png')}</ImageDesktop>
        {!isOpen && (
          <FormStickyWrapper>
            <FormWrapper>
              <FormBlock />
            </FormWrapper>
          </FormStickyWrapper>
        )}
      </TopContainer>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background-size: auto 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #fff;
  padding: 32px 0 1px;
  overflow-x: hidden;

  @media ${DESKTOP} {
    padding: 50px 0 0;
    height: 995.5px;
    background-image: ${({ theme: { imgUrl } }) =>
      imgUrl('top-bg-desk_v2.webp')};
  }

  @media ${TABLET} {
    height: 730px;
    padding: 10px 0 0;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('top-bg-tab_v2.webp')};
  }

  @media ${MOBILE} {
    height: 390px;
    padding: 20px 0 0;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('top-bg-mob_v2.webp')};
    margin-bottom: 120px;
    overflow-x: visible;
  }
`;

const TopContainer = styled(Container)`
  @media ${DESKTOP} {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

const Content = styled.div`
  width: 360px;
  margin-inline-end: 30px;

  @media ${TABLET} {
    width: 310px;
  }

  @media ${MOBILE} {
    width: auto;
    padding-right: 10px;
  }
`;

const Logo = styled.div`
  img {
    width: 150px;
    margin: 0 60px 0 0;
  }

  @media ${MOBILE} {
    margin-bottom: 120px;
    margin-right: -80px;
  }
`;

const Title = styled.div`
  margin: 0 auto 24px;
  font-weight: 700;
  font-size: 42px;
  line-height: 48px;
  text-align: right;
  color: #000000;

  @media ${MOBILE} {
    font-size: 22px;
    line-height: 30px;
  }
`;

const ImageDesktop = styled.div`
  max-width: 366px;
  visibility: hidden;

  @media ${TO_DESKTOP} {
    display: none;
  }
`;

const Text = styled.div`
  font-weight: 400;
  font-size: 19px;
  line-height: 28px;
  text-align: right;
  color: #000000;

  @media ${MOBILE} {
    font-size: 15px;
    line-height: 24px;
  }
`;

const FormStickyWrapper = styled.div`
  @media ${DESKTOP} {
    position: absolute;
    left: calc(50% - 590px);
    top: 123px;
    bottom: 65px;
  }

  @media ${TABLET} {
    display: none;
  }

  @media ${MOBILE} {
    display: none;
  }
`;

const FormWrapper = styled.div`
  @media ${DESKTOP} {
    position: sticky;
    top: 10px;
  }

  @media ${TO_DESKTOP} {
    display: none;
    position: relative;
    margin: 0 auto;
  }

  ${FormWrapperStyles}
`;

Top.propTypes = {
  isOpen: PropTypes.bool,
};

export default Top;
